var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08333 17.6667H15.3333C16.622 17.6667 17.6667 16.622 17.6667 15.3333V6.58334L9.20834 0.75L0.75 6.58334V15.3333C0.75 16.622 1.79467 17.6667 3.08333 17.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58262 13.5822C6.58262 12.2935 7.62729 11.2489 8.91596 11.2489H9.49929C10.788 11.2489 11.8326 12.2935 11.8326 13.5822V17.6655H6.58262V13.5822Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHomeIcon);
export default __webpack_public_path__ + "static/media/black_home_icon.ff694feeab461860837bc3e948081d92.svg";
export { ForwardRef as ReactComponent };